import React, {useEffect, useState} from 'react'
import { connect } from "react-redux";


// components
import ModalNewWishlist from "../../../components/wishlist/tools/ModalNewWishlist";
import WishlistHeader from "../../../components/wishlist/components/WishlistHeader";
import WishlistFitler from "./_filters";
import WishlistList from "./_list";
import { showLoader } from "../../../components/loader/loader";

// actions
import { setApp, clearState } from '../../../redux/actions/generalActions/mainActions'
import { clearState as clearListState } from '../../../redux/actions/generalActions/listActions'

// css
import '../../../assets/css/Wishlist.css'
import WishlistTotales from "../../../components/wishlist/components/WishlistTotales";

const Wishlist = props => {
    const { loading } = props?.mainState
    const selectedUdn =  JSON.parse(localStorage.getItem('selectedUdn') || '{}')

    const [ showNewModal, setShowNewModal ] = useState(false )

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);

        return () => {
            props.clearState()
            props.clearListState()
        }
    },[])

    const handleToggle = () => setShowNewModal(!showNewModal)

    return <>
        { loading && showLoader() }

        <WishlistHeader
            title={ selectedUdn?.label || '' }
            onClick={ handleToggle }
        />

        <WishlistTotales />

        <WishlistFitler />

        <WishlistList />

        <ModalNewWishlist
            isOpen={ showNewModal }
            handleToggle={ handleToggle }
        />
    </>
}

const mapStateToProps = state => ({
    mainState: state.mainProps,
})
const mapActionsToProps = ({
    setApp,
    clearState,
    clearListState,
})

export default connect(mapStateToProps, mapActionsToProps)(Wishlist)